// extracted by mini-css-extract-plugin
export default {"userName":"index_userName_tlg6E clearfix","label":"index_label_OoCiB","input":"index_input_GMwNE","loginregi":"index_loginregi_tBmrQ","error":"index_error_zB7ay"};